'use client';

import Link from 'next/link';

import { useSidebarStore } from '~/lib/store/sidebar.store';

import { LogoImage } from './logos';

interface AppLogoProps {
  href?: string | null;
  className?: string;
  label?: string;
  alwaysOpen?: boolean;
  large?: boolean;
}

export function AppLogo({
  href,
  label,
  className,
  alwaysOpen = false,
  large = false,
}: AppLogoProps) {
  const collapsed = useSidebarStore((state) => state.collapsed);
  const showSmallLogo = !alwaysOpen && collapsed;

  if (href === null) {
    return <LogoImage className={className} large={large} />;
  }

  return (
    <Link aria-label={label ?? 'Home Page'} href={href ?? '/'} prefetch={true}>
      <LogoImage small={showSmallLogo} className={className} large={large} />
    </Link>
  );
}
